/**
 * Shared token refresh for 401 handling.
 * Uses a single promise so multiple concurrent 401s trigger only one Keycloak refresh.
 * Does not statically import store to avoid circular dependency (store mutations import axios).
 */

let refreshPromise = null

async function doRefresh() {
  const store = (await import('@/store')).default
  const keycloak = store.getters.SECURITY_AUTH
  if (!keycloak || !keycloak.updateToken) {
    return Promise.reject(new Error('No Keycloak instance'))
  }
  return keycloak
    .updateToken(70)
    .then((refreshed) => {
      if (refreshed) {
        return store.dispatch('authLogin', keycloak)
      }
    })
    .then(() => {
      refreshPromise = null
    })
    .catch((err) => {
      refreshPromise = null
      if (keycloak && keycloak.login) {
        keycloak.login()
      }
      throw err
    })
}

/**
 * Returns a promise that resolves when the token has been refreshed.
 * If a refresh is already in progress, returns that same promise.
 * Only one refresh runs per burst of 401s.
 * @returns {Promise<void>}
 */
export function getOrStartRefresh() {
  if (refreshPromise !== null) {
    return refreshPromise
  }
  refreshPromise = doRefresh()
  return refreshPromise
}
